export default function preloaderGame13 (scene) {

    scene.load.image(`tilesgame13`, `/tiles/game13.png`);

	// scene.load.spritesheet(`jiu-game13`, 
	// 	`/img/game13/jiu.png`,
	// 	{ frameWidth: 27, frameHeight: 37}
	// );

	// scene.load.spritesheet(`sua-game13`, 
	// 	`/img/game13/sua.png`,
	// 	{ frameWidth: 25.1, frameHeight: 37}
	// );

	scene.load.spritesheet(`siyeon-game13`, 
		`/img/game13/siyeon.png`,
		{ frameWidth: 32, frameHeight: 48}	
	);
	
	// scene.load.spritesheet(`handong-game13`, 
	// 	`/img/game13/handong.png`,
	// 	{ frameWidth: 32, frameHeight: 48}
	// );
	
	scene.load.spritesheet(`yoohyeon-game13`, 
		`/img/game13/yoohyeon.png`,
		{ frameWidth: 32, frameHeight: 48}
	);

	// scene.load.spritesheet(`dami-game13`, 
	// 	`/img/game13/dami.png`,
	// 	{ frameWidth: 32, frameHeight: 48}
	// );
	
	// scene.load.spritesheet(`gahyeon-game13`, 
	// 	`/img/game13/gahyeon.png`,
	// 	{ frameWidth: 27, frameHeight: 37}
	// );

	scene.load.tilemapTiledJSON(`game13`, `/tiles/game13.tmj`);

}